export function getPhoneStyles() {
  return require('./styles.css');
}
